/** @format */

import { Row } from 'components/ui/Grid';
import styled from 'styled-components';

const Wrapper = styled(Row)`
  justify-content: space-between;
  position: relative;
`;

Wrapper.displayName = '   Wrapper';
export default Wrapper;
